import React from "react";
import "./ProductsApplicationDetails.scss"
import ProductsApplicationDetails from "../../features/CorporateCertificate/ProductsApplicationDetails/ProductsApplicationDetails";

const ProductsApplication = () => {
    return (
        <div className="page-container">
            <ProductsApplicationDetails />
        </div>
    );
};
export default ProductsApplication;
